import { defineComponent as _defineComponent } from 'vue'
import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "schedule-container" }
const _hoisted_2 = { class: "details" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "radio" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "radio" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "radio" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "radio" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "online-times-picker"
}

import BusinessHoursSelection from '../businessHoursSelection/BusinessHoursSelection.vue';
import { BusinessHoursOptions } from '../businessHoursSelection';
import { BusinessHoursViewModel } from '../../models';
import { ConditionViewModel } from '@/shared/components/conditions/models/conditionViewModel';
import { computed, PropType, ref, watch } from 'vue';

enum ScheduleType {
  AnyTime,
  InHours,
  OutOfHours,
  CustomTimes,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TriggerScheduler',
  props: {
  condition: {
    type: Object as PropType<ConditionViewModel>,
  },
  openingTimes: {
    type: Array as PropType<BusinessHoursViewModel[]>,
    required: true,
  },
},
  emits: ["updated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const invalid = ref(false);
const selectedSchedule = ref(ScheduleType.AnyTime);
const customTimes = ref<BusinessHoursViewModel[]>([]);
const showCustomTimePicker = computed(() => selectedSchedule.value === ScheduleType.CustomTimes);

watch(
  () => props.openingTimes,
  (openingTimes: BusinessHoursViewModel[]) => (customTimes.value = openingTimes),
  { immediate: true },
);
watch(
  () => props.condition,
  () => (selectedSchedule.value = getSelectedSchedule()),
  { immediate: true },
);

function getSelectedSchedule() {
  if (hasNoSchedule()) {
    return ScheduleType.AnyTime;
  }

  if (isInHours()) {
    if (props.openingTimes.length) {
      return ScheduleType.CustomTimes;
    }
    return ScheduleType.InHours;
  }

  if (!isInHours()) {
    return ScheduleType.OutOfHours;
  }

  return ScheduleType.AnyTime;
}

function hasNoSchedule() {
  return !props.condition || !hasAttribute() || !isScheduleCondition();
}

function isInHours() {
  return (
    props.condition.attribute === 'bot.openingTimes' &&
    props.condition.operation === 'contains' &&
    props.condition.result
  );
}

function switchedScheduleType() {
  invalid.value = false;
  scheduleChanged();
}

function scheduleChanged() {
  if (selectedSchedule.value === ScheduleType.CustomTimes) {
    if (!customTimes.value.length) {
      customTimes.value = [BusinessHoursOptions.getDefaultModel()];
    }
  } else {
    customTimes.value = [];
  }
  emit('updated', createScheduleCondition(selectedSchedule.value), customTimes.value);
}

function setInvalid(value: boolean) {
  invalid.value = value;
}

function createScheduleCondition(type: ScheduleType) {
  switch (type) {
    case ScheduleType.InHours:
    case ScheduleType.CustomTimes:
      return createCondition(true);
    case ScheduleType.OutOfHours:
      return createCondition(false);
  }
}

function isScheduleCondition() {
  if (props.condition.attribute) {
    return props.condition.attribute === 'bot.openingTimes';
  }
  return false;
}

function hasAttribute() {
  return props.condition.attribute && props.condition.attribute.length > 0;
}

function createCondition(inHours: boolean) {
  return {
    attribute: 'bot.openingTimes',
    operation: 'contains',
    type: 'datetime',
    value: 'utcNow',
    result: inHours,
    invalid: invalid.value,
  } as ConditionViewModel;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "schedule-option",
            value: ScheduleType.AnyTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSchedule).value = $event)),
            onChange: switchedScheduleType
          }, null, 40, _hoisted_5), [
            [_vModelRadio, selectedSchedule.value]
          ]),
          _cache[5] || (_cache[5] = _createTextVNode(" At any time ", -1))
        ]),
        _createElementVNode("label", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "schedule-option",
            value: ScheduleType.InHours,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSchedule).value = $event)),
            onChange: switchedScheduleType
          }, null, 40, _hoisted_7), [
            [_vModelRadio, selectedSchedule.value]
          ]),
          _cache[6] || (_cache[6] = _createTextVNode(" During business hours ", -1))
        ]),
        _createElementVNode("label", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "schedule-option",
            value: ScheduleType.OutOfHours,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedSchedule).value = $event)),
            onChange: switchedScheduleType
          }, null, 40, _hoisted_9), [
            [_vModelRadio, selectedSchedule.value]
          ]),
          _cache[7] || (_cache[7] = _createTextVNode(" Outside business hours ", -1))
        ]),
        _createElementVNode("label", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "schedule-option",
            value: ScheduleType.CustomTimes,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedSchedule).value = $event)),
            onChange: switchedScheduleType
          }, null, 40, _hoisted_11), [
            [_vModelRadio, selectedSchedule.value]
          ]),
          _cache[8] || (_cache[8] = _createTextVNode(" Custom ", -1))
        ])
      ]),
      (showCustomTimePicker.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(BusinessHoursSelection, {
              modelValue: customTimes.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customTimes).value = $event)),
              onInput: scheduleChanged,
              allowEmpty: false,
              onError: setInvalid
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})